
import { updateAnalytic as updateAnalyticDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type AnalyticProps = {
    analytic?: string,
}

export const updateAnalytic = ({
    analytic,
}: AnalyticProps) => (
    updateAnalyticDiagram({analytic})
);
